// one per --color-chart-N token in src/tailwind.css
const PALETTE_SIZE = 8;

/** Each id's chart colour by creation order (UUIDv7 ids sort by it), so a new row takes the next one and nobody else's moves. */
export function chartColors(ids: string[]): Record<string, string> {
    return Object.fromEntries([...ids].sort().map((id, index) => [id, `var(--color-chart-${(index % PALETTE_SIZE) + 1})`]));
}
